"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _core = require("core.ui-module_site-components");
var _ApplicationContext = require("../../api/ApplicationContext");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
class ContactUs extends _react.default.Component {
  constructor(props) {
    super(props);
    this.state = {
      isShow: false,
      external: false
    };
  }
  toggleShow(isShow) {
    this.setState({
      isShow
    });
  }
  render() {
    const {
      isShow,
      external
    } = this.state;
    return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement("a", {
      onClick: () => {
        this.toggleShow(true);
      },
      className: "navbar-item contact-us px-3"
    }, "Contact Us"), isShow && /*#__PURE__*/_react.default.createElement(_core.Modal, {
      header: "Contact Us",
      footer: /*#__PURE__*/_react.default.createElement("div", null),
      closeModalCallback: () => {
        this.toggleShow(false);
      }
    }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("h4", null, "Questions/Comments"), /*#__PURE__*/_react.default.createElement("p", null, "Have a question, need login help, or want to provide feedback? We want to hear from you and are here to help. Email us at", ' ', /*#__PURE__*/_react.default.createElement("a", {
      href: `mailto:${_ApplicationContext.ApplicationContext.getContactEmail()}`
    }, _ApplicationContext.ApplicationContext.getContactEmail()), ". Your email will be responded to within one business day."), external && /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement("div", null)))));
  }
}
exports.default = ContactUs;
ContactUs.propTypes = {
  external: _propTypes.default.bool
};
ContactUs.defaultProps = {
  external: undefined
};
//# sourceMappingURL=ContactUs.js.map